import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {HomeGuidebooksSection as SharedHomeGuidebooksSection} from '@chekin/shared/home';
import {HOME_GUIDEBOOKS_ANCHOR} from 'hooks/guidebooks/useHomeGuidebooksPath';
import {useHomeGuidebooks} from './useHomeGuidebooks';

export function HomeGuidebooksSection() {
  const {guidebooks, openGuidebook} = useHomeGuidebooks();
  const {hash, key} = useLocation();
  const hasGuidebooks = guidebooks.length > 0;

  useEffect(() => {
    if (!hasGuidebooks || hash !== `#${HOME_GUIDEBOOKS_ANCHOR}`) return;
    document
      .getElementById(HOME_GUIDEBOOKS_ANCHOR)
      ?.scrollIntoView({behavior: 'smooth', block: 'start'});
  }, [hasGuidebooks, hash, key]);

  return (
    <SharedHomeGuidebooksSection
      id={HOME_GUIDEBOOKS_ANCHOR}
      guidebooks={guidebooks}
      openGuidebook={openGuidebook}
    />
  );
}
